import gettext, { pgettext } from '@sdk/lang/gettext';
import { ModalState } from '@sdk/components/ui/modal/useModalState';

import { DeleteConfirmModal } from '@web/components/DeleteConfirmModal/DeleteConfirmModal';

import { useArchiveConversationModal } from './archiveConversationModal.hooks';

type Props = {
  modalState: ModalState;
};

export const ArchiveConversationModal = ({ modalState }: Props) => {
  const { onSubmit } = useArchiveConversationModal();

  return (
    <DeleteConfirmModal
      modalState={modalState}
      title={gettext('Archive conversation')}
      description={gettext('Are you sure you want to archive this conversation?')}
      onSubmit={onSubmit}
      primaryButtonText={pgettext('text on button', 'Archive')}
    />
  );
};
